<mat-dialog-content class="eligibility-result-dialog-content">
  <div class="header-section mat-header-row">
    <h1 [ngClass]="{ rtl: rightToLeftSite }">
      {{ (customVariables$ | async)?.product_name }}
    </h1>
    <mat-icon
      class="close-cross"
      tabindex="0"
      role="button"
      aria-label="close"
      (click)="onCrossClick()"
      (keyup.enter)="onCrossClick()"
      (keyup.space)="onCrossClick()"
      id="close-eligibility-check"
    >
      close
    </mat-icon>
  </div>
  <div class="modal-body" [ngClass]="{ rtl: rightToLeftSite }">
    <div [translate]="'UserIneligibleMastercard:SubHeader'">Eligibility check</div>

    <div class="icon-container">
      <mat-icon *ngIf="data?.type === 'success'" id="success-eligibility-mark">check</mat-icon>
      <mat-icon *ngIf="data?.type === 'invalid'" id="unsuccess-eligibility-mark">close</mat-icon>
      <h2 id="eligibility-text">{{ (customVariables$ | async)[data?.subtitle] }}</h2>
    </div>

    <ng-container *ngIf="data">
      <p
        *ngFor="let translation of data?.translations; let i = index"
        class="mat-body"
        [innerHTML]="(customVariables$ | async)[(data?.customVarParagraph)[i]] || translation | translate"
      ></p>
    </ng-container>
  </div>
  <div class="bottom-container" *ngIf="data?.type !== 'invalid'">
    <button
      mat-raised-button
      color="primary"
      class="submit-button"
      aria-label="register"
      (click)="onRegister()"
      id="cont-to-register-button"
    >
      <span [translate]="'TermsPopup:Continue'"> Continue </span>
    </button>
  </div>
</mat-dialog-content>
